import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { EnvironmentService } from "./environment.service";
import { PaginationRequest } from "./models/pagination/pagination.request.model";

export interface SendZaloZnsMessageDTO {
    phone: string;
    template_id: string;
    template_data: any;
    tracking_id?: string;
}

@Injectable({ providedIn: 'root' })
export class ZaloZnsApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) {}

    private get baseUrl(): string {
        return `${this.environmentService.getCurrentApiUrl()}/zalo-zns`;
    }

    getListTemplate(): Observable<any> {
        return this.httpClient.get<any>(`${this.baseUrl}/get-list-template`);
    }

    getTemplateDetail(templateId: string): Observable<any> {
        return this.httpClient.get<any>(`${this.baseUrl}/get-template-detail`, {
            params: { templateId: templateId }
        });
    }

    sendZaloZnsMessage(body: SendZaloZnsMessageDTO): Observable<any> {
        return this.httpClient.post<any>(`${this.baseUrl}/send-message`, body);
    }

  
}

